var map = {
	"./1/symbol_0.png": "6abe",
	"./1/symbol_1.png": "31b0",
	"./1/symbol_10.png": "4d2b",
	"./1/symbol_11.png": "a62a",
	"./1/symbol_12.png": "c725",
	"./1/symbol_2.png": "26ec",
	"./1/symbol_3.png": "f6d7",
	"./1/symbol_4.png": "5162",
	"./1/symbol_5.png": "3697",
	"./1/symbol_6.png": "a504",
	"./1/symbol_7.png": "3b4a",
	"./1/symbol_8.png": "98f4",
	"./1/symbol_9.png": "eace",
	"./2/symbol_0.png": "dd3f",
	"./2/symbol_1.png": "df0d",
	"./2/symbol_10.png": "eef8",
	"./2/symbol_11.png": "2c2c",
	"./2/symbol_12.png": "cb90",
	"./2/symbol_2.png": "a368",
	"./2/symbol_3.png": "de0e",
	"./2/symbol_4.png": "185a",
	"./2/symbol_5.png": "bc29",
	"./2/symbol_6.png": "5350",
	"./2/symbol_7.png": "8932",
	"./2/symbol_8.png": "4b38",
	"./2/symbol_9.png": "ab38",
	"./3/symbol_0.png": "cba8",
	"./3/symbol_1.png": "b384",
	"./3/symbol_10.png": "a6c1",
	"./3/symbol_12.png": "7d0a",
	"./3/symbol_2.png": "30c1",
	"./3/symbol_3.png": "ef7c",
	"./3/symbol_4.png": "4ce6",
	"./3/symbol_5.png": "3ff8",
	"./3/symbol_6.png": "a1448",
	"./3/symbol_7.png": "cb63",
	"./3/symbol_8.png": "cc0a",
	"./3/symbol_9.png": "29a7e",
	"./4/symbol_0.png": "93d72",
	"./4/symbol_1.png": "e821a",
	"./4/symbol_10.png": "1602",
	"./4/symbol_12.png": "6fe6",
	"./4/symbol_2.png": "dc1d",
	"./4/symbol_3.png": "2f5c",
	"./4/symbol_4.png": "0b36",
	"./4/symbol_5.png": "1b6e",
	"./4/symbol_6.png": "1e87",
	"./4/symbol_7.png": "7492",
	"./4/symbol_8.png": "c944",
	"./4/symbol_9.png": "afe1",
	"./gold1.png": "cf20",
	"./gold2.png": "aec6",
	"./gold3.png": "b945",
	"./gold4.png": "801d",
	"./silver1.png": "87fa",
	"./silver2.png": "85b3",
	"./silver3.png": "d845",
	"./silver4.png": "b7a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6657";